interface ProgressBarProps {
  valueNow: number;
  valueMin?: number;
  valueMax?: number;
}

const ProgressBar = ({
    valueNow,
    valueMin = 0,
    valueMax = 100,
}:ProgressBarProps) => {
    const width = `${(valueNow / valueMax) * 100}%`;

    return (
        <div
            className="progress"
            role="progressbar"
            aria-label="Default striped example"
            aria-valuenow={valueNow}
            aria-valuemin={valueMin}
            aria-valuemax={valueMax}
        >
            <div className="progress-bar progress-bar-striped" style={{ width }}></div>
        </div>
    );
};

export default ProgressBar;
